
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  FreelanceCompanyPersonResource,
  FreelanceCompanyPersonUpdateRequest,
  ValidationError,
} from '../models';
import {
    FreelanceCompanyPersonResourceFromJSON,
    FreelanceCompanyPersonResourceToJSON,
    FreelanceCompanyPersonUpdateRequestFromJSON,
    FreelanceCompanyPersonUpdateRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface GetPersonRequest {
    companyId: string;
}

export interface UpdatePersonRequest {
    companyId: string;
    freelanceCompanyPersonUpdateRequest: FreelanceCompanyPersonUpdateRequest;
}

/**
 * 
 */
export class FreelancerCompanyPersonApi extends runtime.BaseAPI {

    /**
          */
    async getPersonRaw(requestParameters: GetPersonRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelanceCompanyPersonResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelanceCompanyPersonResource>({
            path: `/compliance/api/company/{companyId}/person`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelanceCompanyPersonResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getPerson(requestParameters: GetPersonRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelanceCompanyPersonResource> {
        const response = await this.getPersonRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async updatePersonRaw(requestParameters: UpdatePersonRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling updatePerson().'
            );
        }

        if (requestParameters['freelanceCompanyPersonUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'freelanceCompanyPersonUpdateRequest',
                'Required parameter "freelanceCompanyPersonUpdateRequest" was null or undefined when calling updatePerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/company/{companyId}/person`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FreelanceCompanyPersonUpdateRequestToJSON(requestParameters['freelanceCompanyPersonUpdateRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async updatePerson(requestParameters: UpdatePersonRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePersonRaw(requestParameters, initOverrides);
    }

}
